<template>
	<div>
		<CModal title="Ouvrir un litige" size="lg" :show.sync="showModal">
			<form ref="mainForm" method="POST" axiosMethod="post" action="/api/support_tickets">
				<CRow>
					<CCol col="6">
						<h5>Destination du colis:</h5>
						<p v-if="orderItem.receiverAddress">
							{{ orderItem.receiverAddress.firstName }}
							{{ orderItem.receiverAddress.lastName }} <br />
							{{ orderItem.receiverAddress.address }} {{ orderItem.receiverAddress.address2 }}
							<br />
							{{ orderItem.receiverAddress.postalCode }}, {{ orderItem.receiverAddress.city }}
							<br />
							{{ orderItem.receiverAddress.country.name }}
						</p>
					</CCol>
					<CCol col="6">
						<h5>Colis sélectionné:</h5>
						<p v-if="orderItem.product">{{ orderItem.product.name }} <br /></p>
					</CCol>
					<input type="hidden" name="orderItem" :value="orderItem['@id']" />

					<CCol col="12">
						<hr />
					</CCol>

					<CCol col="12">
						<GTreeView
							inputName="complaintReason"
							label="Raison du litige"
							placeholder="Recherchez une raison de litige"
							label-prop="text"
							:multiple="false"
							fetch-url="/api/complaint_reasons?itemsPerPage=100" />
					</CCol>

					<CCol col="12">
						<GTextarea name="comment" label="Commentaire(s)" />
					</CCol>

					<CCol col="12">
						<CSelect
							name="contactChannel"
							label="Moyen de contact"
							:options="contactChannelOptions" />
					</CCol>

					<CCol col="12">
						<CSelect name="contactBy" label="Contacté par" :options="contactByOptions" />
					</CCol>
				</CRow>
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GTreeView from '../ghostlexly-components/GTreeView';
	import GTextarea from '../ghostlexly-components/GInputs/GTextarea';

	export default {
		name: 'add-ticket-on-package',

		components: { GTextarea, GTreeView },

		data() {
			return {
				showModal: false,
				orderItem: {},
				contactByOptions: [
					{
						label: 'Expéditeur',
						value: 'support_ticket.contact_by.sender',
					},
					{
						label: 'Destinataire',
						value: 'support_ticket.contact_by.receiver',
					},
				],
				contactChannelOptions: [
					{
						label: 'Téléphone',
						value: 'support_ticket.contact_channel.phone',
					},
					{
						label: 'E-mail',
						value: 'support_ticket.contact_channel.email',
					},
					{
						label: 'Internet',
						value: 'support_ticket.contact_channel.web',
					},
					{
						label: 'Lettre',
						value: 'support_ticket.contact_channel.letter',
					},
				],
			};
		},

		methods: {
			async onSubmit(form) {
				await this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.showModal = false;
						if (res.data.id) {
							this.$router.push(`/orders/customer-service/tickets/${res.data.id}/edit`);
						}
					}
				});
			},
		},
	};
</script>
